import React, { useEffect, useState } from "react";
import * as yup from "yup";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  InputAdornment,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { connect, useSelector } from "react-redux";
import { useXssGuard } from "Hooks/useXssGuard";
import regex from "constants/regex";
import { PrimaryDialogTitle } from "../../Components/Common/Dialog/DialogComponents";
import { makeStyles } from "@mui/styles";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import "../../Sass/Common.scss";
import { START_PROFILE_UPDATE } from "../../Actions/PatientAction";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment from "moment";
import { START_GET_LOGIN_USER } from "../../Actions/UserAction";
import { Padding } from "@mui/icons-material";
const useStyle = makeStyles((theme) => ({
  rsDialogMainRoot: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      [theme.breakpoints.down("1112")]: {
        maxWidth: "70% !important",
      },
      [theme.breakpoints.down("768")]: {
        maxWidth: "90% !important",
      },
    },
  },
  rsPassword: {
    left: "20px !important",
    "&>svg": {
      height: "20px",
      width: "20px",
    },
  },
  dailogActions:{
    padding:"15px !important"
  }
}));

const EditProfileDialog = (props) => {
  const {
    open,
    setOpen,
    pharmacyRecordActionType,
    profileUpdate,
    createPharmacyData,
    updatePharmacyData,
    resetPharmacyState,
    profileUpdateAction,
    getLoginUserAction,
  } = props;
  const classes = useStyle();
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    dob: "",
  });
  const [passwordData, setPasswordData] = useState({
    new_password: "",
    confirm_password: "",
    old_password: "",
  });
  const [showPassword, setShowPassword] = React.useState(false);
  const loginUserDetail = useSelector((state) => state.user);
  const [tableTab, setTableTab] = useState("details");
  const [isOpenDate, setIsOpenDate] = React.useState(false);
  const showDataBasedOnRole =
    loginUserDetail?.loginUserDetail?.data?.data?.role;
  const [showPasswordCurrent, setShowPasswordCurrent] = React.useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = React.useState(false);
  /** Edit data show useEffect */
  useEffect(() => {
    setUserData({
      name: loginUserDetail?.loginUserDetail?.data?.data?.name,
      email: loginUserDetail?.loginUserDetail?.data?.data?.email,
      dob: loginUserDetail?.loginUserDetail?.data?.data?.dob,
    });
  }, [open]);

  /** Handle Close Function */
  const handleClose = () => {
    setOpen(false);
    setUserData({
      name: "",
      email: "",
      dob: "",
    });
    // setEditData({});
    resetForm();
    resetFormpassword();
    setShowPassword(false);
    setShowPasswordConfirm(false);
    setPasswordData({
      confirm_password: "",
      new_password: "",
      old_password: "",
    });
  };

  /** Handle Create & Update Pharmacy */
  const handleAddUser = (formValues) => {
    const payload = {
      name: formValues?.name,
      type: "profile",
      dob: formValues?.dob
        ? moment(new Date(formValues?.dob)).format("YYYY-MM-DD")
        : null,
    };
    profileUpdateAction(payload);
  };

  const { guardedSubmit: xssGuardedAddUser } = useXssGuard(handleAddUser);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  /* Password Validation Schema */
  const handleClickShowPasswordCurrent = () =>
    setShowPasswordCurrent((show) => !show);
  const handleClickShowPasswordConfirm = () =>
    setShowPasswordConfirm((show) => !show);

  const addSchema = yup.object().shape({
    name: yup
      .string()
      .required("Name is required field")
      .matches(/^[A-Za-z ]*$/, "Numbers are not allowed in the name"),
    email: yup
      .string()
      .email("Email should be valid")
      .required("Email is required field"),
    dob: yup
      .date()
      .nullable()
      .typeError("Date must be follow this format DD-MM-YYYY")
      // .required("The date of birth field is required.")
      .max(new Date(), "The DOB can not be the future date"),
  });

  /** UseFormik */
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    dirty,
    touched,
    handleBlur,
    resetForm,
    setErrors,
    setFieldValue,
  } = useFormik({
    initialValues: { ...userData },
    validationSchema: addSchema,
    enableReinitialize: true,
    onSubmit: xssGuardedAddUser,
  });
  /** handle note schema  */
  const addPasswordSchema = yup.object().shape({
    old_password: yup
      .string()
      .required("Password is required field.")
      .min(8, "Password length should be atleast 8 characters.")
      .matches(
        /^(?=.*[a-z])/,
        "password must contain at least 1 lower case letter"
      )
      .matches(
        /^(?=.*[A-Z])/,
        "password must contain at least 1 upper case letter"
      )
      .matches(/^(?=.*[0-9])/, "password must contain at least 1 number")
      .matches(
        regex.password,
        "password must contain at least 1 special character"
      ),
    new_password: yup
      .string()
      .required("Password is required field.")
      .min(8, "Password length should be atleast 8 characters.")
      .matches(
        /^(?=.*[a-z])/,
        "password must contain at least 1 lower case letter"
      )
      .matches(
        /^(?=.*[A-Z])/,
        "password must contain at least 1 upper case letter"
      )
      .matches(/^(?=.*[0-9])/, "password must contain at least 1 number")
      .matches(
        regex.password,
        "password must contain at least 1 special character"
      ),
    confirm_password: yup
      .string()
      .required("Confirm Password is required field.")
      .oneOf(
        [yup.ref("new_password"), null],
        "Confirm password should be same as password"
      ),
  });
  const handleUpdatePassword = (formValues) => {
    const payload = {
      type: "credential",
      old_password: formValues?.old_password,
      password: formValues?.new_password,
      confirm_password: formValues?.confirm_password,
    };
    profileUpdateAction(payload);
  };

  const { guardedSubmit: xssGuardedUpdatePwd } = useXssGuard(handleUpdatePassword);

  const {
    handleSubmit: handleSubmitPassword,
    handleChange: handleChangePassword,
    values: valuespassword,
    errors: errorspassword,
    touched: touchedpassword,
    handleBlur: handleBlurpassword,
    resetForm: resetFormpassword,
    setErrors: setErrorspassword,
  } = useFormik({
    initialValues: { ...passwordData },
    enableReinitialize: true,
    validationSchema: addPasswordSchema,
    onSubmit: xssGuardedUpdatePwd,
  });

  useEffect(() => {
    if (profileUpdate?.data?.success) {
      setOpen(false);
      getLoginUserAction();
    }

    const errors = profileUpdate.error?.errors;
    if (errors && Object?.keys(errors)?.length > 0) {
      let obj = {};
      Object.entries(errors)?.map(([item, value]) => {
        obj[item] = value[0];
        return item;
      });
      setErrorspassword(obj);
      setErrors(obj);
    }
  }, [profileUpdate]);
  return (
    <>
      <Dialog
        open={open}
        maxWidth={"md"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        className={classes.rsDialogMainRoot}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
      >
        <PrimaryDialogTitle handleClose={handleClose} title={"Edit Profile"} />
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tableTab}
            // onChange={handleChangetab}
            aria-label="basic tabs example"
          >
            <Tab
              label="Details"
              value="details"
              onClick={() => {
                setTableTab("details");
              }}
            />
            <Tab
              label="Password"
              value="password"
              onClick={() => {
                setTableTab("password");
              }}
            />
          </Tabs>
        </Box>
        {tableTab === "details" && (
          <form
            name="registration"
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
              var name = document.registration.name.value;
              const firstError = Object.keys(errors).reduce((field, a) => {
                return !!errors[field] ? field : a;
              }, null);
              if (name === null || name === "") {
                document.getElementById("name")?.focus();
              } else if (firstError === "name") {
                document.getElementById("name")?.focus();
              } else if (firstError === "email") {
                document.getElementById("email")?.focus();
              } else if (firstError === "dob") {
                document.getElementById("dob")?.focus();
              }
            }}
          >
            <DialogContent>
              <Grid container columnSpacing={2.5} rowSpacing={3}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    placeholder="Name *"
                    label="Name *"
                    size="small"
                    id="name"
                    name="name"
                    value={values?.name}
                    error={touched?.name && errors?.name}
                    helperText={touched?.name && errors?.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      disableFuture
                      label="Date of birth"
                      views={["year", "month", "day"]}
                      inputFormat="DD-MM-YYYY"
                      value={values?.dob ? values?.dob : "" || null}
                      onFocus={() => setIsOpenDate(true)}
                      open={() => setIsOpenDate(true)}
                      onClose={() => {
                        setIsOpenDate(false);
                      }}
                      onChange={(newDate) => {
                        setFieldValue("dob", newDate);
                      }}
                      renderInput={(params) => (
                        <TextField
                          id="dob"
                          fullWidth
                          size="small"
                          inputFormat="DD-MM-YYYY"
                          name="dob"
                          {...params}
                          error={touched?.dob && errors?.dob}
                          helperText={touched?.dob && errors?.dob}
                          onBlur={handleBlur}
                        />
                      )}
                      name="dob"
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    placeholder="Email Address *"
                    label="Email Address *"
                    type="email"
                    size="small"
                    id="email"
                    name="email"
                    disabled
                    value={values?.email}
                    error={touched?.email && errors?.email}
                    helperText={touched?.email && errors?.email}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={handleBlur}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className={classes.dailogActions}>
              <Button
                disabled={profileUpdate?.loading}
                startIcon={
                  profileUpdate?.loading && (
                    <CircularProgress color="white" size="20px" />
                  )
                }
                variant="contained"
                type="submit"
              >
                Submit
              </Button>
              <Button variant="outlined" onClick={() => handleClose()}>
                Cancel
              </Button>
            </DialogActions>
          </form>
        )}
        {tableTab === "password" && (
          <form
            name="registration"
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmitPassword();
            }}
          >
            <DialogContent>
              <Grid container columnSpacing={2.5} rowSpacing={3}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    placeholder="Current Password *"
                    label="Current Password *"
                    size="small"
                    id="old_password"
                    name="old_password"
                    autoFocus={true}
                    type={showPasswordCurrent ? "text" : "password"}
                    value={valuespassword?.old_password}
                    error={
                      touchedpassword?.old_password &&
                      errorspassword?.old_password
                    }
                    helperText={
                      touchedpassword?.old_password &&
                      errorspassword?.old_password
                    }
                    onChange={handleChangePassword}
                    onBlur={handleBlurpassword}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            onClick={handleClickShowPasswordCurrent}
                            className={classes.rsPassword}
                          >
                            {showPasswordCurrent ? (
                              <VisibilityOutlinedIcon />
                            ) : (
                              <VisibilityOffOutlinedIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    placeholder="New Password *"
                    label="New Password *"
                    size="small"
                    id="new_password"
                    name="new_password"
                    type={showPassword ? "text" : "password"}
                    value={valuespassword?.new_password}
                    error={
                      touchedpassword?.new_password &&
                      errorspassword?.new_password
                    }
                    helperText={
                      touchedpassword?.new_password &&
                      errorspassword?.new_password
                    }
                    onChange={handleChangePassword}
                    onBlur={handleBlurpassword}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            onClick={handleClickShowPassword}
                            className={classes.rsPassword}
                          >
                            {showPassword ? (
                              <VisibilityOutlinedIcon />
                            ) : (
                              <VisibilityOffOutlinedIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    placeholder="Confirm Password  *"
                    label="Confirm Password *"
                    type={showPasswordConfirm ? "text" : "password"}
                    // type="confirm_password"
                    size="small"
                    id="confirm_password"
                    name="confirm_password"
                    value={valuespassword?.confirm_password}
                    error={
                      touchedpassword?.confirm_password &&
                      errorspassword?.confirm_password
                    }
                    helperText={
                      touchedpassword?.confirm_password &&
                      errorspassword?.confirm_password
                    }
                    onChange={(e) => {
                      handleChangePassword(e);
                    }}
                    onBlur={handleBlurpassword}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            onClick={handleClickShowPasswordConfirm}
                            className={classes.rsPassword}
                          >
                            {showPasswordConfirm ? (
                              <VisibilityOutlinedIcon />
                            ) : (
                              <VisibilityOffOutlinedIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className={classes.dailogActions}>
              <Button
                disabled={profileUpdate?.loading}
                startIcon={
                  profileUpdate?.loading && (
                    <CircularProgress color="white" size="20px" />
                  )
                }
                variant="contained"
                type="submit"
              >
                Submit
              </Button>
              <Button variant="outlined" onClick={() => handleClose()}>
                Cancel
              </Button>
            </DialogActions>
          </form>
        )}
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => ({
  profileUpdate: state.patient.profileUpdate,
});
const mapDispatchToProps = (dispatch) => ({
  profileUpdateAction: (payload) =>
    dispatch({ type: START_PROFILE_UPDATE, payload }),
  getLoginUserAction: () => dispatch({ type: START_GET_LOGIN_USER }),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditProfileDialog);
